(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-texture-filter", [], factory);
	else if(typeof exports === 'object')
		exports["layer-texture-filter"] = factory();
	else
		root["layer-texture-filter"] = factory();
})(self, function() {
return 